An opaque cursor to the earlier bounding webhook subscription.

Resulting webhook subscriptions will _succeed_ this cursor.
